<div class="container" *ngIf="investorProfile">
  
  <div class="investor-tabs" role="tablist" aria-label="Investor menu tabs">
    <button
      type="button"
      class="investor-tab"
      [class.active]="activeTab === 'information'"
      (click)="goTab('information')">
      Registration Information
    </button>
    <button
      type="button"
      class="investor-tab"
      [class.active]="activeTab === 'company'"
      (click)="goTab('company')">
      Interested Company
    </button>
    <button *ngIf="eventType !== eventTypeEnum.DIGITALROADSHOW"
      type="button"
      class="investor-tab"
      [class.active]="activeTab === 'availableTime'"
      (click)="goTab('availableTime')">
      Available Times
    </button>
    <button
      type="button"
      class="investor-tab"
      [class.active]="activeTab === 'meetingSchedule'"
      (click)="goTab('meetingSchedule')">
      Meeting Schedule
    </button>
    <button *ngIf="isShowHotel && eventType !== eventTypeEnum.DIGITALROADSHOW"
      type="button"
      class="investor-tab"
      [class.active]="activeTab === 'hotel'"
      (click)="goTab('hotel')">
      Hotel
    </button>
  </div>

  <div class="info-note-box shadow-sm mb-3" *ngIf="isClosedRegis">
    <i class="fas fa-info-circle info-note-icon"></i>
    <div>Remark: Unable to edit after registration period {{startDate | date: 'MMM dd, yyyy'}} - {{endDate | date: 'MMM dd, yyyy'}}</div>
  </div>

  <ng-container [ngSwitch]="activeTab">

    <app-investor-profile
      *ngSwitchCase="'information'"
      [profileForm]="profileForm"
      [eventInfoWithConsent]="eventInfoWithConsent"
      [isClosedRegis]="isClosedRegis"
      (onSuccessEvent)="onSaveProfile($event)">
    </app-investor-profile>

    <app-investor-company
      *ngSwitchCase="'company'"
      [form]="companySelectionForm"
      [eventInfoWithConsent]="eventInfoWithConsent"
      [isClosedRegis]="isClosedRegis"
      [defaultMeetingType]="defaultMeetingType"
      [defaultMeetingPriority]="defaultMeetingPriority"
      [attendancePreference]="attendancePreference"
      (onSuccessEvent)="onSaveCompanySelection($event)">
    </app-investor-company>

    <app-investor-time
      *ngSwitchCase="'availableTime'"
      [form]="timeSelectionForm"
      [eventInfoWithConsent]="eventInfoWithConsent"
      [isClosedRegis]="isClosedRegis"
      (onSuccessEvent)="onSaveTimeSelection()">
    </app-investor-time>

    <app-investor-meeting-schedule
      *ngSwitchCase="'meetingSchedule'"
      [isSentScheduleEmail]="investorProfile.isSentScheduleEmail"
      [contactEmail]="eventInfoWithConsent.emailFrom">
    </app-investor-meeting-schedule>

    <app-investor-hotel
      *ngSwitchCase="'hotel'"
      [event]="eventInfoWithConsent">
    </app-investor-hotel>
    
  </ng-container>

</div>